// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"361":"ddbdf057","436":"0b0fe9b3"}[chunkId] + ".chunk.js";
};